import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=20c701ce&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=20c701ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c701ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c701ce')) {
      api.createRecord('20c701ce', component.options)
    } else {
      api.reload('20c701ce', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=20c701ce&scoped=true&", function () {
      api.rerender('20c701ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/strategy/detail.vue"
export default component.exports